import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Stack,
    Checkbox
} from '@mui/material';

function CardTable({ cards = [], selectedCards = new Set(), onCardSelect = () => {} }) {
    const handleSelectAll = () => {
        const currentPageCardIds = new Set(cards.map(card => card.id));
        const currentPageSelected = cards.filter(card => selectedCards.has(card.id));
        
        if (currentPageSelected.length === cards.length) {
            // Unselect all cards on current page (keep selections from other pages)
            const newSelected = new Set(selectedCards);
            currentPageCardIds.forEach(id => newSelected.delete(id));
            onCardSelect(newSelected);
        } else {
            // Select all cards on current page (keep existing selections from other pages)
            const newSelected = new Set(selectedCards);
            currentPageCardIds.forEach(id => newSelected.add(id));
            onCardSelect(newSelected);
        }
    };

    const handleCardSelect = (cardId) => {
        const newSelected = new Set(selectedCards);
        if (newSelected.has(cardId)) {
            newSelected.delete(cardId);
        } else {
            newSelected.add(cardId);
        }
        onCardSelect(newSelected);
    };

    const renderReviewers = (reviewers) => {
        if (!reviewers || reviewers.length === 0) {
            return (
                <Chip
                    label="No reviewers assigned"
                    size="small"
                    variant="outlined"
                    color="error"
                />
            );
        }

        return (
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                {reviewers.map((reviewer) => (
                    <Chip
                        key={reviewer.id}
                        label={`${reviewer.first_name} ${reviewer.last_name}`}
                        size="small"
                        variant="filled"
                        color="primary"
                    />
                ))}
            </Stack>
        );
    };

    // Calculate checkbox states for current page
    const currentPageSelected = cards.filter(card => selectedCards.has(card.id));
    const isIndeterminate = currentPageSelected.length > 0 && currentPageSelected.length < cards.length;
    const isAllSelected = cards.length > 0 && currentPageSelected.length === cards.length;

    return (
        <TableContainer sx={{ overflowY: 'scroll', boxShadow: 2, backgroundColor: 'white', borderRadius: 2 }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow className='tableHeader'>
                        <TableCell>
                            <Checkbox
                                indeterminate={isIndeterminate}
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                                title={'Select/deselect all cards on current page'}
                            />
                        </TableCell>
                        <TableCell>External Card ID</TableCell>
                        <TableCell>Card Name</TableCell>
                        <TableCell>Physician</TableCell>
                        <TableCell>Specialty</TableCell>
                        <TableCell>Assigned Reviewers</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cards.map((card) => (
                        <TableRow key={card.id} hover>
                            <TableCell>
                                <Checkbox
                                    checked={selectedCards.has(card.id)}
                                    onChange={() => handleCardSelect(card.id)}
                                />
                            </TableCell>
                            <TableCell>{card.external_card_id}</TableCell>
                            <TableCell>{card.name}</TableCell>
                            <TableCell>{`Dr. ${card.owner.name}`}</TableCell>
                            <TableCell>{card.owner?.specialty || 'No specialty'}</TableCell>
                            <TableCell sx={{ minWidth: 200 }}>
                                {renderReviewers(card.reviewers)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default CardTable;